import { render, staticRenderFns } from "./academicCalenderCreation.vue?vue&type=template&id=52d40494"
import script from "./academicCalenderCreation.vue?vue&type=script&lang=js"
export * from "./academicCalenderCreation.vue?vue&type=script&lang=js"
import style0 from "./academicCalenderCreation.vue?vue&type=style&index=0&id=52d40494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports